import type { TenantStrings } from '@web-config-app/core';
import { EN_CONFIG_APP_STRINGS } from '../configs/strings';

/**
 * Returns an object of localized strings merged with the default/common strings.
 * Any localization in the passed {@link TenantStrings} that implements a translation key
 * inside of `EN_STRING_OVERRIDES` will override that string.
 *
 * Currently, the only locale supported is `en`.
 */

export const mergeTenantStrings = (
  tenantStrings?: TenantStrings,
): TenantStrings => ({
  en: {
    ...EN_CONFIG_APP_STRINGS,
    ...tenantStrings?.en,
  },
});
